import React from 'react'
import { useSelector } from 'react-redux'
import { money } from '../../utils/helpers'

const CartBottom = () => {
  const { cart } = useSelector((state) => state.cart)
  const makePermalink = () => {
    return cart.items.map((item) => `${item.variant_id}:${item.quantity}`).join(',')
  }

  return (
    <div className="pt-6 border-t before:border-[rgba(33,33,33,0.25)]">
      <div className="flex justify-between text-fore text-sm leading-4 mb-6">
        {window.cartStrings.subtotal}
        <span className="text-fore text-sm leading-4">{money(cart.items_subtotal_price)}</span>
      </div>
      <a className="button button--primary w-full" href="/checkout">
        {window.cartStrings.checkout}
      </a>
      <a
        className="button !border !border-solid !border-black w-full mt-3.5"
        href={`/cart/${makePermalink()}?payment=shop_pay`}
      >
        <img className="h-5" src={window.globalIcons['icon-shop-pay']} alt="ShopPay" loading="lazy" />
      </a>
    </div>
  )
}

export default CartBottom
